<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo"> 
      <i class="fas fa-users-cog icon"></i>
        Estamento
      </div>
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul> 
            <li>
              <router-link :to="{name:'administrativeHome'}" >
                <span >
                  <i class="fas fa-home icon"></i>                  
                   inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'stament'}">
                <span>
                 <i class="fas fa-user-cog icon"></i>
                  Estamentos
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">

          <createStament 
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :closeBasic="closeBasic"
          :chargeStamentList="chargeStamentList"
          :stament_id="stament_id">
          </createStament>
          <b-button type="is-primary is-small" @click="openBasic()">Crear Estamento</b-button>

          <b-table type="is-primary"
            :data.sync="listStament"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="stablishment.name"
            aria-next-label="Next page"            
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Nombre">{{ props.row.name }}</b-table-column>

              <b-table-column label="Action">
                        <b-button type="is-primary is-small" @click="editBasic(props.row.id)">Editar</b-button>

              </b-table-column>
            </template>
          </b-table>
          
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from '../../../../template/PlantillaContenido'
import createStament from '../../../../components/manteiners/stament/create';

export default {
  components: {
    PlantillaContenido,
    createStament
  },
  data() {
    return {
      stament_id: null,
      listStament: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeStamentList();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.stament_id = null;
      this.isComponentModalActive = false;
    },
    editBasic(id) {
      this.stament_id = id;
      this.isComponentModalActive = true;
    },
    chargeStamentList() {
      this.loading = true;
      this.listStament = [];
      this.$http.get(`api/${localStorage.getItem('perfil')}/stament`).then(
        response => {
          this.listStament = response.body.data;
          console.log('asasas',response.body.data)
          this.loading = false;
        },
        response => {
          console.log("error: ", response);
        }
      );
    }
  },
  
};
</script>

